/* eslint-disable */
/* tslint:disable */

import { HttpClient, RequestParams } from "./http-client";

class Files<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
	/**
	 * No description
	 *
	 * @request GET:/files/{...}
	 * @secure
	 */
	list = (str: string, params: RequestParams = {}) =>
		this.request<any, void>({
			path: `/files/${str}`,
			method: "GET",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @request GET:/files/commissions/{...}
	 * @secure
	 */
	commissionsList = (params: RequestParams = {}) =>
		this.request<any, void>({
			path: `/files/commissions/{...}`,
			method: "GET",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @request GET:/files/enums/{...}
	 * @secure
	 */
	enumsList = (params: RequestParams = {}) =>
		this.request<any, void>({
			path: `/files/enums/{...}`,
			method: "GET",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @request GET:/files/fstek-export-bundles/{...}
	 * @secure
	 */
	fstekExportBundlesList = (params: RequestParams = {}) =>
		this.request<any, void>({
			path: `/files/fstek-export-bundles/{...}`,
			method: "GET",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @request GET:/files/fstek-letters/{...}
	 * @secure
	 */
	fstekLettersList = (params: RequestParams = {}) =>
		this.request<any, void>({
			path: `/files/fstek-letters/{...}`,
			method: "GET",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @request GET:/files/organization-markers/{...}
	 * @secure
	 */
	organizationMarkersList = (params: RequestParams = {}) =>
		this.request<any, void>({
			path: `/files/organization-markers/{...}`,
			method: "GET",
			secure: true,
			...params,
		});
}
export const filesAPI = new Files();
